import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import '@org/scene-layout/styles.css';
import './index.css';

Sentry.init({
  dsn: 'https://2acb1c3ea56c2c8a0833a7e6b29c317a@o4511218378932224.ingest.us.sentry.io/4511218383454208',
  environment: import.meta.env.MODE,
  release: __COMMIT_SHA__,
  sendDefaultPii: true,
  integrations: [
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: 'light',
      formTitle: 'Report a Bug',
      submitButtonLabel: 'Send Report',
      messagePlaceholder: 'What happened? What were you doing when it broke?',
      showBranding: false,
      showName: false,
      isEmailRequired: false,
      emailLabel: 'Email (optional)',
      themeLight: {
        foreground: '#7a6a4a',
        background: '#fdf6e3',
        accentBackground: '#4a3a1a',
        accentForeground: '#fdf6e3',
      },
    }),
  ],
});

/* ---------- Global error handlers ---------- */

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Global] Unhandled promise rejection:', event.reason);
});

window.onerror = (message, source, lineno, colno, error) => {
  console.error('[Global] Uncaught error:', { message, source, lineno, colno, error });
};

/* ---------- Render ---------- */

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);

// SW registered via inline script in index.html for PWA detection.
// Listen for updates on the existing registration.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready.then((reg) => {
    reg.addEventListener('updatefound', () => {
      const newWorker = reg.installing;
      if (!newWorker) return;
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          window.dispatchEvent(new CustomEvent('sw-update-available'));
        }
      });
    });
  });
}

navigator.storage?.persist?.();
